import backToBlog from './backToBlog';
import navigation from './navigation';
import progress from './progress';
import redirect from './redirect';
import share from './share';
import subscribe from './subscribe';

redirect();
navigation();
subscribe();
progress();
backToBlog();
share();
